<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "scientificResearch"
}
</script>

<style scoped>

</style>